import { createTheme, responsiveFontSizes } from "@mui/material";

// colors
// const black = "#343a40";
const darkBlack = "rgb(36, 40, 44)";
// const background = "#f5f5f5";
// const white = "#fefefe"


// border
const borderThickness = 2;
const borderColor = "rgba(0, 0, 0, 0.13)";

// breakpoints
const xl = 1920;
const lg = 1280;
const md = 960;
const sm = 600;
const xs = 0;

export const breakpoints = {
  xl,
  lg,
  md,
  sm,
  xs
};

// spacing
const spacing = 8;
const doubleSpacing = 16;

const mainTheme = createTheme({
  palette: {
    // common: {
    //   black,
    //   white
    // },
    primary: {
      light: "#7ebeff",
      main: "#3e8ef7",
      dark: "#0061c3",
      contrastText: "#fff",
    },
    secondary: {
      light: "#c992ff",
      main: "#9463f7",
      dark: "#5f36c3",
      contrastText: "#fff",
    },
    error: {
      light: "#ff817e",
      main: "#ff4c52",
      dark: "#c50029",
      contrastText: "#fff",
    },
    warning: {
      light: "#ffff58",
      main: "#ffcd17",
      dark: "#c79d00",
      contrastText: "#fff",
    },
    info: {
      light: "#63e4ff",
      main: "#0bb2d4",
      dark: "#0082a3",
      contrastText: "#fff",
    },
    success: {
      light: "#60f69c",
      main: "#11c26d",
      dark: "#009040",
      contrastText: "#fff",
    },
    // Used to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: 0.2,
    // background: {
    //   default: background
    // }
  },
  breakpoints: {
    // Define custom breakpoint values.
    // These will apply to Material-UI components that use responsive
    // breakpoints, such as `Grid` and `Hidden`. You can also use the
    // theme breakpoint functions `up`, `down`, and `between` to create
    // media queries for these breakpoints
    values: {
      xl,
      lg,
      md,
      sm,
      xs
    }
  },
  components: {
    // MuiExpansionPanel: {
    //   styleOverrides: {
    //     root: {
    //       position: "static"
    //     }
    //   }
    // },
    MuiTableCell: {
      styleOverrides: {
        root: {
          paddingLeft: doubleSpacing,
          paddingRight: doubleSpacing,
          borderBottom: `${borderThickness}px solid ${borderColor}`,
          [`@media (max-width:  ${sm}px)`]: {
            paddingLeft: spacing,
            paddingRight: spacing
          }
        }
      }
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          backgroundColor: borderColor,
          height: borderThickness
        }
      }
    },
    MuiListItem: {
      styleOverrides: {
        divider: {
          borderBottom: `${borderThickness}px solid ${borderColor}`
        }
      }
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          width: "100%",
          maxWidth: 430,
          marginLeft: spacing,
          marginRight: spacing
        }
      }
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: darkBlack
        }
      }
    },

    // MuiExpansionPanelDetails: {
    //   root: {
    //     [`@media (max-width:  ${sm}px)`]: {
    //       paddingLeft: spacing,
    //       paddingRight: spacing
    //     }
    //   }
    // }
  }
});

export default responsiveFontSizes(mainTheme);
